import { useClient } from '@composables/use-clients';
import {
  PutRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type SkillTreeAttributeSerializerType = {
  name: string;
};

export type PutSkillTreeAttributeArgsType = PutRequestArgsType<SkillTreeAttributeSerializerType> & {
  skillTreeCode: string;
};

export const apiUpdateSkillTreeAttribute = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: PutSkillTreeAttributeArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.skillTreeAttribute({ domain, skillTreeCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
